/**
 * --------------------------------------------------------------------------
 * Bootstrap (v5.0.0-alpha1): liens-evitement.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */

import {
  getjQuery
} from './util/index'
import Data from './dom/data'
import EventHandler from './dom/event-handler'
import SelectorEngine from './dom/selector-engine'

/**
 * ------------------------------------------------------------------------
 * Constants
 * ------------------------------------------------------------------------
 */

const NAME = 'skiplinks'
const VERSION = '5.0.0-alpha1'
const DATA_KEY = 'bs.skiplinks'
const EVENT_KEY = `.${DATA_KEY}`
// const DATA_API_KEY = '.data-api'

const CLASS_NAME_ACTIVE = 'active'

const SELECTOR_LINKS = '.skiplinks a'

const EVENT_FOCUS = `focus${EVENT_KEY}`
// const EVENT_FOCUS_DATA_API = `focus${EVENT_KEY}${DATA_API_KEY}`
const EVENT_BLUR = `blur${EVENT_KEY}`
// const EVENT_BLUR_DATA_API = `blur${EVENT_KEY}${DATA_API_KEY}`
const EVENT_CLICK = `click${EVENT_KEY}`
// const EVENT_CLICK_DATA_API = `click${EVENT_KEY}${DATA_API_KEY}`

/**
 * ------------------------------------------------------------------------
 * Class Definition
 * ------------------------------------------------------------------------
 */

class LiensEvitement {
  constructor(element) {
    this._list = element
    this._links = SelectorEngine.find(SELECTOR_LINKS, this._list).filter(link => !(link.id === 'versmain'))
    // console.log(this._links)

    this._addEventListeners()
    Data.setData(element, DATA_KEY, this)
  }

  // Getters

  static get VERSION() {
    return VERSION
  }

  // Public

  show() {
    this._list.classList.add(CLASS_NAME_ACTIVE)
  }

  hide() {
    this._list.classList.remove(CLASS_NAME_ACTIVE)
  }

  focusTarget(event) {
    event.preventDefault()
    event.stopPropagation()
    if (!event.target) {
      return
    }

    const targetQuerys = event.target.dataset.ineaTargetFocus.split(',')
    for (const targetQuery of targetQuerys) {
      const target = SelectorEngine.findOne(targetQuery)
      if (target) {
        target.focus()
      }
    }
  }

  dispose() {
    Data.removeData(this._list, DATA_KEY)
    EventHandler.off(this._list, EVENT_KEY)
    this._list = null
    this._links = null
  }

  // Private

  _addEventListeners() {
    this._links.forEach(link => {
      EventHandler.on(link, EVENT_FOCUS, _ => this.show())
      // EventHandler.on(link, EVENT_FOCUS_DATA_API, _ => this.show())

      EventHandler.on(link, EVENT_BLUR, _ => this.hide())
      // EventHandler.on(link, EVENT_BLUR_DATA_API, _ => this.hide())

      EventHandler.on(link, EVENT_CLICK, event => this.focusTarget(event))
      // EventHandler.on(link, EVENT_CLICK_DATA_API, event => this.focusTarget(event))
    })
  }

  // Static

  static jQueryInterface(config) {
    return this.each(function () {
      let data = Data.getData(this, DATA_KEY)

      if (!data) {
        data = new LiensEvitement(this)
      }

      if (config === 'show') {
        data[config]()
      }
    })
  }

  static getInstance(element) {
    return Data.getData(element, DATA_KEY)
  }
}

const $ = getjQuery()

/**
 * ------------------------------------------------------------------------
 * jQuery
 * ------------------------------------------------------------------------
 * add .skiplinksfocus to jQuery only if jQuery is present
 */
/* istanbul ignore if */
if ($) {
  const JQUERY_NO_CONFLICT = $.fn[NAME]
  $.fn[NAME] = LiensEvitement.jQueryInterface
  $.fn[NAME].Constructor = LiensEvitement
  $.fn[NAME].noConflict = () => {
    $.fn[NAME] = JQUERY_NO_CONFLICT
    return LiensEvitement.jQueryInterface
  }
}

export default LiensEvitement
